import { Component, ViewEncapsulation, OnInit, ViewChild, ViewContainerRef, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW1308Model } from './kymw1308.model';
import { KYMW1309Component } from '../kymw1309/kymw1309.component';
import { PlessDialogServiceSub } from '../../../../../src/app/commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { FlexGrid, SelectionMode } from '@grapecity/wijmo.grid';
import { KYMW1308OutputModel } from './vo/kymw1308-output.model';
import { KYMW1308InputModel } from './vo/kymw1308-input.model';
import { KYMW1308GetPlanGoodsInfoModel } from './vo/kymw1308-get-plan-goods-info.model';
import { GetPlanGoodsInfoService } from './api-service/get-plan-goods-info.service';
import { KYMW1309OutputModel } from '../kymw1309/vo/kymw1309-output.model';
import { GetPromotionNoService } from './api-service/get-promotion-no.service';
import { KYMW1309InputModel } from '../kymw1309/vo/kymw1309-input.model';
import { PlessAlert } from '../../../../../src/app/shared/pless-alert/pless-alert.component';
import { RegistPromotionGoodsService } from './api-service/regist-promotion-goods.service';
import { RadioLabelComponent } from '../../../../../src/app/commons/kymw02/radio-label/radio-label.component';
import { KYMW1308GetPromotionNoModel } from './vo/kymw1308-get-promotion-no.model';
import { KYMW1308GetPromotionGoodsInfoModel } from './vo/kymw1308-get-promotion-goods-info.model';
import { KYMW1308CalcApprovedPriceModel } from './vo/kymw1308-calc-approved-price.model';
import { KYMW1308DiscountGoodsModel } from './vo/kymw1308-discount-goods.model';
import { KYMW1308RegistPromotionGoodsModel } from './vo/kymw1308-regist-promotion-goods.model';
import { KYMW1308PromotionGoodsRegistModel } from './vo/kymw1308-promotion-goods-regist.model';
import { PlessViewUtilsSub } from '../../../../../src/app/commons/kymw00/pless-view-utils-sub.service';
import { GetPromotionGoodsInfoService } from './api-service/get-promotion-goods-info.service';
import { CalcApprovedPriceService } from './api-service/calc-approved-price.service';
import { PlanGoodsLockService } from '../../../../../src/app/commons/kymw00/api-services/plan-goods-lock.service';
import { IEditableCollectionView } from '@grapecity/wijmo';

const enum COLUMN {
  PCODE = 0,
  GOODS_NAME = 1,
  STANDARD_NAME = 2,
  SUPPLY_PRICE_IB = 3,
  COST_PRICE_IB = 4,
  APPROVED_NUM_IB = 5,
  APPROVED_PRICE_IB = 6,
  WAKUWAKU_POINT_IB = 7,
  SUPPLY_PRICE_TO = 8,
  COST_PRICE_TO = 9,
  APPROVED_NUM_TO = 10,
  APPROVED_PRICE_TO = 11,
  WAKUWAKU_POINT_TO = 12,
  SUPPLY_PRICE_GU = 13,
  COST_PRICE_GU = 14,
  APPROVED_NUM_GU = 15,
  APPROVED_PRICE_GU = 16,
  WAKUWAKU_POINT_GU = 17,
  SUPPLY_PRICE_TI = 18,
  COST_PRICE_TI = 19,
  APPROVED_NUM_TI = 20,
  APPROVED_PRICE_TI = 21,
  WAKUWAKU_POINT_TI = 22,
  SUPPLY_PRICE_SA = 23,
  COST_PRICE_SA = 24,
  APPROVED_NUM_SA = 25,
  APPROVED_PRICE_SA = 26,
  WAKUWAKU_POINT_SA = 27,
  SUPPLY_PRICE_TK = 28,
  COST_PRICE_TK = 29,
  APPROVED_NUM_TK = 30,
  APPROVED_PRICE_TK = 31,
  WAKUWAKU_POINT_TK = 32,
  SUPPLY_PRICE_NA = 33,
  COST_PRICE_NA = 34,
  APPROVED_NUM_NA = 35,
  APPROVED_PRICE_NA = 36,
  WAKUWAKU_POINT_NA = 37,
  SUPPLY_PRICE_NI = 38,
  COST_PRICE_NI = 39,
  APPROVED_NUM_NI = 40,
  APPROVED_PRICE_NI = 41,
  WAKUWAKU_POINT_NI = 42,
  SUPPLY_PRICE_KU = 43,
  COST_PRICE_KU = 44,
  APPROVED_NUM_KU = 45,
  APPROVED_PRICE_KU = 46,
  WAKUWAKU_POINT_KU = 47,
}

/**
 * バンドルミックスマッチ設定画面を管理するクラス
 *
 * @export KYMW1308Component
 * @class KYMW1308Component
 */
@Component({
  selector: 'app-kymw1308',
  templateUrl: 'kymw1308.component.html',
  styleUrls: ['kymw1308.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1308Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;

  KYMW1308Model: KYMW1308Model = new KYMW1308Model();
  setKYMW1308Parameter: Function;

  // バンドルミックスマッチ設定画面用インプットVO
  private inputVO: KYMW1308InputModel;

  private readonly DIV_BUNDLE: string = <string>'B';
  private readonly DIV_MIX: string = <string>'P';
  private readonly DIV_POINT: string = <string>'T';
  private readonly SELECT_ALL: string = <string>'1';

  @ViewChild('btn_Reflection', { static: true }) public btn_Reflection: ElementRef;
  @ViewChild('dtg_PromotionInfo', { static: true }) dtg_PromotionInfo: FlexGrid;
  @ViewChild('rbt_Bundle', { static: true }) rbt_Bundle: RadioLabelComponent;
  @ViewChild('txt_ApprovedNum', { static: true }) public txt_ApprovedNum: ElementRef;
  @ViewChild('cmb_PromotionNo', { static: true }) public cmb_PromotionNo: ElementRef;

  /**
   * Creates an instance of KYMW1308Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {ViewContainerRef} viewContainerRef
   * @param {KYMW00Model} kymw00Model
   * @param {ElementRef} elementRef
   * @param {GetPlanGoodsInfoService} getPlanGoodsInfoService
   * @param {GetPromotionGoodsInfoService} getPromotionGoodsInfoService
   * @param {GetPromotionNoService} getPromotionNoService
   * @param {CalcApprovedPriceService} calcApprovedPriceService
   * @param {RegistPromotionGoodsService} registPromotionGoodsService
   * @param {PlanGoodsLockService} planGoodsLockServiceSub
   * @memberof KYMW1308Component
   */
  constructor(
    public dialogService: PlessDialogServiceSub,
    private viewContainerRef: ViewContainerRef,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private getPlanGoodsInfoService: GetPlanGoodsInfoService,
    private getPromotionGoodsInfoService: GetPromotionGoodsInfoService,
    private getPromotionNoService: GetPromotionNoService,
    private calcApprovedPriceService: CalcApprovedPriceService,
    private registPromotionGoodsService: RegistPromotionGoodsService,
    private planGoodsLockServiceSub: PlanGoodsLockService,
  ) {
    super(kymw00Model);
  }

  /**
   * インプットVO設定
   *
   * @param {*} inputVO インプットVO
   * @returns {void}
   * @memberof KYMW1308Component
   */
  public setInputVO(inputVO: any): void {

    // 受渡情報の設定（再描画時）
    this.inputVO = <KYMW1308InputModel>(inputVO);

    // 処理区分のチェック
    if (this.inputVO.accessDiv === '1') {                                       // 「1：バンドルミックスマッチ設定」の場合
      // コマ割画面にて、編集ロックが「閲覧モード」に切り替わった際、
      // または、コマ割画面にて、受注コード、媒体区分コンボボックスの値が変更された場合、
      // 画面を閉じる
      if ((!this.inputVO.editLock                                               // 編集ロック
        && this.KYMW1308Model.editLock !== this.inputVO.editLock)               // 編集ロック
        || this.KYMW1308Model.orderCode !== this.inputVO.orderCode              // 受注コード
        || this.KYMW1308Model.mediumType !== this.inputVO.mediumType) {         // 媒体区分
        this.eventClose_CLICKHandler(null);
      }

      // InputVO ⇒ Manage
      this.KYMW1308Model.editLock = this.inputVO.editLock;                      // 編集ロック
      this.KYMW1308Model.editLockBtn = this.inputVO.editLock;                   // 編集ロック
      this.KYMW1308Model.orderCode = this.inputVO.orderCode;                    // 受注コード
      this.KYMW1308Model.mediumType = this.inputVO.mediumType;                  // 媒体区分
      this.KYMW1308Model.promotionNo = this.inputVO.promotionNo;                // プロモーションＮＯ
      this.KYMW1308Model.discountPercent = '';                                  // 値引率
      this.KYMW1308Model.promotionInfo = new Array<any>();                      // プロモーション情報

      // プロモーション商品情報取得更新
      this.updatePromotionGoodsInfo();

      // 処理復帰
      return;
    }

    const getPlanGoodsInfoVO: KYMW1308GetPlanGoodsInfoModel = new KYMW1308GetPlanGoodsInfoModel();
    let blnAddFlg: boolean = <boolean>false;

    if (this.inputVO.pCodeList == null ||
      this.inputVO.pCodeList.length < 1) {
      this.KYMW1308Model.editLock = this.inputVO.editLock;
      this.KYMW1308Model.editLockBtn = this.inputVO.editLock;

      this.setEnabledBtn();
      return;
    }

    getPlanGoodsInfoVO.orderCode = this.KYMW1308Model.orderCode;

    this.KYMW1308Model.sortDirection = this.dtg_PromotionInfo.collectionView.sortDescriptions.map(function (sortDesc) {
      return { property: sortDesc.property, ascending: sortDesc.ascending };
    });

    for (const inputPCode of this.inputVO.pCodeList) {

      blnAddFlg = true;

      for (const promotionGoodsInfoVO of this.KYMW1308Model.promotionInfo) {
        if (inputPCode === promotionGoodsInfoVO.pCode) {
          blnAddFlg = false;
          break;
        }
      }

      if (blnAddFlg) {
        getPlanGoodsInfoVO.pCodeList.push(inputPCode);
      }
    }

    if (getPlanGoodsInfoVO.pCodeList.length < 1) {
      return;
    }

    if (this.KYMW1308Model.promotionDiv === this.DIV_BUNDLE ||
      this.KYMW1308Model.promotionDiv === this.DIV_POINT) {
      let strDiv: string = <string>'';

      if (this.KYMW1308Model.promotionDiv === this.DIV_BUNDLE) {
        strDiv = 'バンドル';
      } else {
        strDiv = 'わくわくポイント';
      }

      if (this.KYMW1308Model.promotionInfo.length > 0 ||
        getPlanGoodsInfoVO.pCodeList.length > 1) {
        this.dialogService.openAlertGetMessage('E0201', [strDiv, '1'], null);
        return;
      }
    }

    // 企画商品情報取得要求をサーバに送信
    this.getPlanGoodsInfoService.execute(this.KYMW1308Model, getPlanGoodsInfoVO);
  }

  /**
   * バンドルミックスマッチ検索画面OutputVO設定
   *
   * @param {KYMW1309OutputModel} outputVO
   * @memberof KYMW1308Component
   */
  public setKYMW1309Parameter(outputVO: KYMW1309OutputModel): void {

    // 処理区分のチェック
    if (outputVO.accessDiv === '1') {                                           // 「1：検索」の場合
      // VO⇒Manage
      this.KYMW1308Model.accessPromotionDiv = outputVO.promotionDiv;
      this.KYMW1308Model.accessPromotionName = outputVO.promotionName;
      this.KYMW1308Model.accessCoopCode = outputVO.coopCode;
      this.KYMW1308Model.accessPCode = outputVO.pCode;
      this.KYMW1308Model.accessClassCode = outputVO.classCode;
    } else if (outputVO.accessDiv === '2') {                                    // 「2：選択」の場合
      this.KYMW1308Model.promotionNo = outputVO.promotionNo;

      // プロモーション商品情報取得要求をサーバに送信
      this.getPromotionGoodsInfoService.execute(this.KYMW1308Model, this.createGetPromotionGoodsInfoVO());
    }
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1308Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1308';
    this.KYMW1308Model.KYMW1308Component = this;
    this.planGoodsLockService = this.planGoodsLockServiceSub;
    this.dtg_PromotionInfo.columnHeaders.rows[0].height = 70;

    // InputVO ⇒ Manage
    this.KYMW1308Model.editLock = this.inputVO.editLock;                        // 編集ロック
    this.KYMW1308Model.editLockBtn = this.inputVO.editLock;                     // 編集ロック
    this.KYMW1308Model.orderCode = this.inputVO.orderCode;                      // 受注コード
    this.KYMW1308Model.mediumType = this.inputVO.mediumType;                    // 媒体区分
    this.KYMW1308Model.promotionNo = this.inputVO.promotionNo;                  // プロモーションＮＯ

    // プロモーションＮＯ取得要求をサーバに送信
    this.getPromotionNoService.execute(this.KYMW1308Model, this.createGetPromotionNoVO());

    this.cmb_PromotionNo.nativeElement.focus();
  }

  /**
   * プロモーション区分ラジオボタングループ_アイテムクリック時に呼び出されるメソッド
   *
   * @param {Event} event
   * @memberof KYMW1308Component
   */
  public eventDiv_CHANGEHandler(event: Event): void {
    this.setEnabledDiv();
  }

  /**
   * 設定単位ラジオボタングループ_アイテムクリック時に呼び出されるメソッド
   *
   * @param {Event} event
   * @memberof KYMW1308Component
   */
  public eventUnit_CHANGEHandler(event: Event): void {
    this.setEnabledUnit();
  }

  /**
   * プロモーションＮＯコンボボックス_チェンジ時に呼び出されるメソッド
   *
   * @param {Event} event
   * @memberof KYMW1308Component
   */
  public eventNo_CHANGEHandler(event: Event): void {

    if (this.KYMW1308Model.promotionNo === '') {
      // 画面項目初期化
      this.initDisplay();

      // ボタン活性制御
      this.setEnabledBtn();
    } else {
      // プロモーション商品情報取得要求をサーバに送信
      this.getPromotionGoodsInfoService.execute(this.KYMW1308Model, this.createGetPromotionGoodsInfoVO());
    }
  }

  /**
   * 「検索」ボタン押下イベント処理
   *
   * @param {Event} event
   * @memberof KYMW1308Component
   */
  public eventSearch_CLICKHandler(event: Event): void {
    const componentRef = this.dialogService.openModal(KYMW1309Component);
    const instance = componentRef.componentInstance as KYMW1309Component;
    instance.parent = this;
    instance.closeFunction = () => {
      componentRef.close();
    };
    instance.setKYMW1309Parameter = (outputVo: KYMW1309OutputModel) => {
      this.setKYMW1309Parameter(outputVo);
    };

    // パラメータ設定
    const kymw1309vo: KYMW1309InputModel = new KYMW1309InputModel();

    kymw1309vo.orderCode = this.KYMW1308Model.orderCode;
    kymw1309vo.mediumType = this.KYMW1308Model.mediumType;
    kymw1309vo.promotionDiv = this.KYMW1308Model.accessPromotionDiv;
    kymw1309vo.promotionName = this.KYMW1308Model.accessPromotionName;
    kymw1309vo.coopCode = this.KYMW1308Model.accessCoopCode;
    kymw1309vo.pCode = this.KYMW1308Model.accessPCode;
    kymw1309vo.classCode = this.KYMW1308Model.accessClassCode;

    instance.setInterfaceParam(kymw1309vo);
  }

  /**
   * 一括反映ボタン_クリック時に呼び出されるメソッド
   *
   * @param {Event} event
   * @returns {void}
   * @memberof KYMW1308Component
   */
  public eventReflection_CLICKHandler(event: Event): void {

    if (this.KYMW1308Model.promotionDiv === this.DIV_BUNDLE ||
      this.KYMW1308Model.promotionDiv === this.DIV_MIX) {

      if (this.KYMW1308Model.approvedNum === '') {
        this.dialogService.openAlertGetMessage('W0001', ['成立数量'], null);
        return;
      }

      if (Number(this.KYMW1308Model.approvedNum) < 2) {
        this.dialogService.openAlertGetMessage('E0142', ['成立数量', '2'], null);
        return;
      }

      if (this.KYMW1308Model.approvedPrice.length > 0 &&
        this.KYMW1308Model.discountPercent.length > 0) {
        this.dialogService.openAlertGetMessage('E0165', ['成立価格', '値引率'], null);
        return;
      }
    } else if (this.KYMW1308Model.promotionDiv === this.DIV_POINT) {
      if (this.KYMW1308Model.wakuwakuPoint.length < 1) {
        this.dialogService.openAlertGetMessage('W0001', ['わくわくポイント'], null);
        return;
      }
    }

    if (this.KYMW1308Model.coopIB === false &&
      this.KYMW1308Model.coopTO === false &&
      this.KYMW1308Model.coopGU === false &&
      this.KYMW1308Model.coopTI === false &&
      this.KYMW1308Model.coopSA === false &&
      this.KYMW1308Model.coopTK === false &&
      this.KYMW1308Model.coopNA === false &&
      this.KYMW1308Model.coopNI === false &&
      this.KYMW1308Model.coopKU === false) {
      this.dialogService.openAlertGetMessage('E0103', ['反映対象の生協'], null);
      return;
    }

    if (this.KYMW1308Model.reflectionTarget !== this.SELECT_ALL &&
      this.dtg_PromotionInfo.selection.row === -1) {
      this.dialogService.openAlertGetMessage('E0103', ['商品'], null);
      return;
    }

    if (this.KYMW1308Model.promotionDiv === this.DIV_POINT) {
      this.reflectPromotion('', '', this.KYMW1308Model.wakuwakuPoint);

      // グリッド再描画
      this.dtg_PromotionInfo.refresh(true);
    } else if (this.KYMW1308Model.discountPercent.length > 0) {
      // 成立価格算出要求をサーバに送信
      this.calcApprovedPriceService.execute(this.KYMW1308Model, this.createCalcApprovedPriceVO());
    } else {
      this.reflectPromotion(this.KYMW1308Model.approvedNum, this.KYMW1308Model.approvedPrice, '');
      // グリッド再描画
      setTimeout(() => {
        this.dtg_PromotionInfo.refresh(true);
      });
    }
  }

  /**
   * 行削除ボタン_クリック時に呼び出されるメソッド
   *
   * @param {Event} event
   * @returns {void}
   * @memberof KYMW1308Component
   */
  public eventDelRow_CLICKHandler(event: Event): void {
    if (this.dtg_PromotionInfo.selection.row === -1) {
      this.dialogService.openAlertGetMessage('E0103', ['商品'], null);
      return;
    }

    // ロック情報リリース
    this.LockUtilForPlanGoods('RELEASE',
      this.KYMW1308Model.orderCode,
      this.KYMW1308Model.mediumType,
      this.KYMW1308Model.promotionInfo[this.dtg_PromotionInfo.selection.row].pCode,
      null,
      null,
      null,
      null,
      false);

    const cv: IEditableCollectionView = this.dtg_PromotionInfo.editableCollectionView;
    cv.removeAt(this.dtg_PromotionInfo.selection.row);

    this.setEnabledBtn();
  }

  /**
   * 全削除ボタン_クリック時に呼び出されるメソッド
   *
   * @param {Event} event コールバック・イベントへの参照
   * @memberof KYMW1308Component
   */
  public eventDelAll_CLICKHandler(event: Event): void {
    // ロック情報リリース
    if (this.KYMW1308Model.promotionInfo != null &&
      this.KYMW1308Model.promotionInfo.length > 0) {
      const pCodeList: Array<any> = new Array<any>();

      for (const vo of this.KYMW1308Model.promotionInfo) {
        pCodeList.push(vo.pCode);
      }

      this.LockUtilForPlanGoods('RELEASE',
        this.KYMW1308Model.orderCode,
        this.KYMW1308Model.mediumType,
        pCodeList,
        null,
        null,
        null,
        null,
        false);
    }

    const cv: IEditableCollectionView = this.dtg_PromotionInfo.editableCollectionView;
    for (let i: number = cv.items.length; i >= 0; i--) {
      cv.removeAt(i);
    }

    this.setEnabledBtn();
  }

  /**
   * 設定ボタン_クリック時に呼び出されるメソッド
   *
   * @param {Event} event コールバック・イベントへの参照
   * @returns {void}
   * @memberof KYMW1308Component
   */
  public eventRegist_CLICKHandler(event: Event): void {

    this.KYMW1308Model.promotionNo = String(this.KYMW1308Model.promotionNo);

    let strDiv: string = <string>'';
    let strMes: string = <string>'';

    if (this.KYMW1308Model.promotionDiv === this.DIV_BUNDLE) {
      strDiv = 'バンドル設定';
    } else if (this.KYMW1308Model.promotionDiv === this.DIV_MIX) {
      strDiv = 'ミックスマッチ設定';
    } else {
      strDiv = 'わくわくポイント設定';
    }

    let strNumIB: string = <string>'';
    let strNumTO: string = <string>'';
    let strNumGU: string = <string>'';
    let strNumTI: string = <string>'';
    let strNumSA: string = <string>'';
    let strNumTK: string = <string>'';
    let strNumNA: string = <string>'';
    let strNumNI: string = <string>'';
    let strNumKU: string = <string>'';
    let intMixFlgIB: number = <number>0;
    let intMixFlgTO: number = <number>0;
    let intMixFlgGU: number = <number>0;
    let intMixFlgTI: number = <number>0;
    let intMixFlgSA: number = <number>0;
    let intMixFlgTK: number = <number>0;
    let intMixFlgNA: number = <number>0;
    let intMixFlgNI: number = <number>0;
    let intMixFlgKU: number = <number>0;
    const blnConfirm: boolean = <boolean>false;

    if (this.KYMW1308Model.promotionInfo.length < 1) {
      if (this.KYMW1308Model.promotionNo.length < 1) {
        this.dialogService.openAlertGetMessage('E0109', [], null);
        return;
      }

      this.dialogService.openAlertGetMessage('Q0106', [strDiv], (closeDetail: number) => this.eventDeleteConfirm_CLICKHandler(closeDetail));

    } else {
      if (this.KYMW1308Model.promotionDiv === this.DIV_BUNDLE ||
        this.KYMW1308Model.promotionDiv === this.DIV_MIX) {

        for (const vo1 of this.KYMW1308Model.promotionInfo) {

          if (vo1.approvedNumIB.length < 1 &&
            vo1.approvedNumTO.length < 1 &&
            vo1.approvedNumGU.length < 1 &&
            vo1.approvedNumTI.length < 1 &&
            vo1.approvedNumSA.length < 1 &&
            vo1.approvedNumTK.length < 1 &&
            vo1.approvedNumNA.length < 1 &&
            vo1.approvedNumNI.length < 1 &&
            vo1.approvedNumKU.length < 1) {

            strMes = '『' + vo1.pCode + ':' + vo1.guideGoodsName + '』の成立数量';

            this.dialogService.openAlertGetMessage('W0001', [strMes], null);

            return;
          }

          if (this.checkBundleMix(vo1.pCode,
            vo1.guideGoodsName,
            this.kymw00Model.COOP_IB,
            vo1.thisTimeSupplyPriceIB,
            vo1.approvedNumIB,
            vo1.approvedPriceIB,
            blnConfirm) === false) {
            return;
          }

          if (this.checkBundleMix(vo1.pCode,
            vo1.guideGoodsName,
            this.kymw00Model.COOP_TO,
            vo1.thisTimeSupplyPriceTO,
            vo1.approvedNumTO,
            vo1.approvedPriceTO,
            blnConfirm) === false) {
            return;
          }

          if (this.checkBundleMix(vo1.pCode,
            vo1.guideGoodsName,
            this.kymw00Model.COOP_GU,
            vo1.thisTimeSupplyPriceGU,
            vo1.approvedNumGU,
            vo1.approvedPriceGU,
            blnConfirm) === false) {
            return;
          }

          if (this.checkBundleMix(vo1.pCode,
            vo1.guideGoodsName,
            this.kymw00Model.COOP_TI,
            vo1.thisTimeSupplyPriceTI,
            vo1.approvedNumTI,
            vo1.approvedPriceTI,
            blnConfirm) === false) {
            return;
          }

          if (this.checkBundleMix(vo1.pCode,
            vo1.guideGoodsName,
            this.kymw00Model.COOP_SA,
            vo1.thisTimeSupplyPriceSA,
            vo1.approvedNumSA,
            vo1.approvedPriceSA,
            blnConfirm) === false) {
            return;
          }

          if (this.checkBundleMix(vo1.pCode,
            vo1.guideGoodsName,
            this.kymw00Model.COOP_TK,
            vo1.thisTimeSupplyPriceTK,
            vo1.approvedNumTK,
            vo1.approvedPriceTK,
            blnConfirm) === false) {
            return;
          }

          if (this.checkBundleMix(vo1.pCode,
            vo1.guideGoodsName,
            this.kymw00Model.COOP_NA,
            vo1.thisTimeSupplyPriceNA,
            vo1.approvedNumNA,
            vo1.approvedPriceNA,
            blnConfirm) === false) {
            return;
          }

          if (this.checkBundleMix(vo1.pCode,
            vo1.guideGoodsName,
            this.kymw00Model.COOP_NI,
            vo1.thisTimeSupplyPriceNI,
            vo1.approvedNumNI,
            vo1.approvedPriceNI,
            blnConfirm) === false) {
            return;
          }

          if (this.checkBundleMix(vo1.pCode,
            vo1.guideGoodsName,
            this.kymw00Model.COOP_KU,
            vo1.thisTimeSupplyPriceKU,
            vo1.approvedNumKU,
            vo1.approvedPriceKU,
            blnConfirm) === false) {
            return;
          }

          if (vo1.approvedNumIB.length > 0) {
            if (strNumIB.length > 0) {
              if (vo1.approvedNumIB === strNumIB) {
                if (intMixFlgIB === 1) {
                  intMixFlgIB = 2;
                }
              } else {
                intMixFlgIB = 3;
              }
            } else {
              strNumIB = vo1.approvedNumIB;
              intMixFlgIB = 1;
            }
          }
          if (vo1.approvedNumTO.length > 0) {
            if (strNumTO.length > 0) {
              if (vo1.approvedNumTO === strNumTO) {
                if (intMixFlgTO === 1) {
                  intMixFlgTO = 2;
                }
              } else {
                intMixFlgTO = 3;
              }
            } else {
              strNumTO = vo1.approvedNumTO;
              intMixFlgTO = 1;
            }
          }
          if (vo1.approvedNumGU.length > 0) {
            if (strNumGU.length > 0) {
              if (vo1.approvedNumGU === strNumGU) {
                if (intMixFlgGU === 1) {
                  intMixFlgGU = 2;
                }
              } else {
                intMixFlgGU = 3;
              }
            } else {
              strNumGU = vo1.approvedNumGU;
              intMixFlgGU = 1;
            }
          }
          if (vo1.approvedNumTI.length > 0) {
            if (strNumTI.length > 0) {
              if (vo1.approvedNumTI === strNumTI) {
                if (intMixFlgTI === 1) {
                  intMixFlgTI = 2;
                }
              } else {
                intMixFlgTI = 3;
              }
            } else {
              strNumTI = vo1.approvedNumTI;
              intMixFlgTI = 1;
            }
          }
          if (vo1.approvedNumSA.length > 0) {
            if (strNumSA.length > 0) {
              if (vo1.approvedNumSA === strNumSA) {
                if (intMixFlgSA === 1) {
                  intMixFlgSA = 2;
                }
              } else {
                intMixFlgSA = 3;
              }
            } else {
              strNumSA = vo1.approvedNumSA;
              intMixFlgSA = 1;
            }
          }
          if (vo1.approvedNumTK.length > 0) {
            if (strNumTK.length > 0) {
              if (vo1.approvedNumTK === strNumTK) {
                if (intMixFlgTK === 1) {
                  intMixFlgTK = 2;
                }
              } else {
                intMixFlgTK = 3;
              }
            } else {
              strNumTK = vo1.approvedNumTK;
              intMixFlgTK = 1;
            }
          }
          if (vo1.approvedNumNA.length > 0) {
            if (strNumNA.length > 0) {
              if (vo1.approvedNumNA === strNumNA) {
                if (intMixFlgNA === 1) {
                  intMixFlgNA = 2;
                }
              } else {
                intMixFlgNA = 3;
              }
            } else {
              strNumNA = vo1.approvedNumNA;
              intMixFlgNA = 1;
            }
          }
          if (vo1.approvedNumNI.length > 0) {
            if (strNumNI.length > 0) {
              if (vo1.approvedNumNI === strNumNI) {
                if (intMixFlgNI === 1) {
                  intMixFlgNI = 2;
                }
              } else {
                intMixFlgNI = 3;
              }
            } else {
              strNumNI = vo1.approvedNumNI;
              intMixFlgNI = 1;
            }
          }
          if (vo1.approvedNumKU.length > 0) {
            if (strNumKU.length > 0) {
              if (vo1.approvedNumKU === strNumKU) {
                if (intMixFlgKU === 1) {
                  intMixFlgKU = 2;
                }
              } else {
                intMixFlgKU = 3;
              }
            } else {
              strNumKU = vo1.approvedNumKU;
              intMixFlgKU = 1;
            }
          }
        }

        if (this.KYMW1308Model.promotionDiv === this.DIV_MIX) {

          switch (intMixFlgIB) {
            case 1:
              this.dialogService.openAlertGetMessage('E0227', [this.kymw00Model.COOP_IB], null);
              return;
            case 3:
              this.dialogService.openAlertGetMessage('E0166', [this.kymw00Model.COOP_IB], null);
              return;
          }

          switch (intMixFlgTO) {
            case 1:
              this.dialogService.openAlertGetMessage('E0227', [this.kymw00Model.COOP_TO], null);
              return;
            case 3:
              this.dialogService.openAlertGetMessage('E0166', [this.kymw00Model.COOP_TO], null);
              return;
          }

          switch (intMixFlgGU) {
            case 1:
              this.dialogService.openAlertGetMessage('E0227', [this.kymw00Model.COOP_GU], null);
              return;
            case 3:
              this.dialogService.openAlertGetMessage('E0166', [this.kymw00Model.COOP_GU], null);
              return;
          }

          switch (intMixFlgTI) {
            case 1:
              this.dialogService.openAlertGetMessage('E0227', [this.kymw00Model.COOP_TI], null);
              return;
            case 3:
              this.dialogService.openAlertGetMessage('E0166', [this.kymw00Model.COOP_TI], null);
              return;
          }

          switch (intMixFlgSA) {
            case 1:
              this.dialogService.openAlertGetMessage('E0227', [this.kymw00Model.COOP_SA], null);
              return;
            case 3:
              this.dialogService.openAlertGetMessage('E0166', [this.kymw00Model.COOP_SA], null);
              return;
          }

          switch (intMixFlgTK) {
            case 1:
              this.dialogService.openAlertGetMessage('E0227', [this.kymw00Model.COOP_TK], null);
              return;
            case 3:
              this.dialogService.openAlertGetMessage('E0166', [this.kymw00Model.COOP_TK], null);
              return;
          }

          switch (intMixFlgNA) {
            case 1:
              this.dialogService.openAlertGetMessage('E0227', [this.kymw00Model.COOP_NA], null);
              return;
            case 3:
              this.dialogService.openAlertGetMessage('E0166', [this.kymw00Model.COOP_NA], null);
              return;
          }

          switch (intMixFlgNI) {
            case 1:
              this.dialogService.openAlertGetMessage('E0227', [this.kymw00Model.COOP_NI], null);
              return;
            case 3:
              this.dialogService.openAlertGetMessage('E0166', [this.kymw00Model.COOP_NI], null);
              return;
          }

          switch (intMixFlgKU) {
            case 1:
              this.dialogService.openAlertGetMessage('E0227', [this.kymw00Model.COOP_KU], null);
              return;
            case 3:
              this.dialogService.openAlertGetMessage('E0166', [this.kymw00Model.COOP_KU], null);
              return;
          }
        }

        if (blnConfirm) {

          if (this.KYMW1308Model.promotionNo.length > 0) {

            this.dialogService.openAlertGetMessage(
              'Q0248', ['更新'], (closeDetail: number) => this.eventRegistConfirm_CLICKHandler(closeDetail));

          } else {

            this.dialogService.openAlertGetMessage(
              'Q0248', ['登録'], (closeDetail: number) => this.eventRegistConfirm_CLICKHandler(closeDetail));

          }

          return;

        }
      } else if (this.KYMW1308Model.promotionDiv === this.DIV_POINT) {

        for (const vo2 of this.KYMW1308Model.promotionInfo) {

          if (vo2.wakuwakuPointIB.length < 1 &&
            vo2.wakuwakuPointTO.length < 1 &&
            vo2.wakuwakuPointGU.length < 1 &&
            vo2.wakuwakuPointTI.length < 1 &&
            vo2.wakuwakuPointSA.length < 1 &&
            vo2.wakuwakuPointTK.length < 1 &&
            vo2.wakuwakuPointNA.length < 1 &&
            vo2.wakuwakuPointNI.length < 1 &&
            vo2.wakuwakuPointKU.length < 1) {

            strMes = '『' + vo2.pCode + ':' + vo2.guideGoodsName + '』のわくわくポイント';

            this.dialogService.openAlertGetMessage('W0001', [strMes], null);

            return;
          }
        }
      }

      if (this.KYMW1308Model.promotionNo.length > 0) {
        this.dialogService.openAlertGetMessage(
          'Q0105', [strDiv], (closeDetail: number) => this.eventRegistConfirm_CLICKHandler(closeDetail));
      } else {
        this.dialogService.openAlertGetMessage(
          'Q0104', [strDiv], (closeDetail: number) => this.eventRegistConfirm_CLICKHandler(closeDetail));
      }
    }
  }

  /**
   * 閉じるボタンクリック時の処理
   *
   * @param {MouseEvent} event
   * @memberof KYMW1308Component
   */
  public eventClose_CLICKHandler(event: MouseEvent): void {

    // ロック情報リリース
    if (this.KYMW1308Model.promotionInfo != null &&
      this.KYMW1308Model.promotionInfo.length > 0) {

      const pCodeList: Array<any> = new Array<any>();

      for (const vo of this.KYMW1308Model.promotionInfo) {
        pCodeList.push(vo.pCode);
      }

      this.LockUtilForPlanGoods('RELEASE',
        this.KYMW1308Model.orderCode,
        this.KYMW1308Model.mediumType,
        pCodeList,
        null,
        null,
        null,
        null,
        false);
    }

    super.onClickClose();
  }

  /**
   * 確認メッセージ_ボタンクリック時の処理
   *
   * @param {number} closeDetail
   * @memberof KYMW1308Component
   */
  public eventRegistConfirm_CLICKHandler(closeDetail: number): void {
    if (closeDetail === PlessAlert.Yes) {
      // 成立価格算出要求をサーバに送信
      this.registPromotionGoodsService.execute(this.KYMW1308Model, this.createRegistPromotionGoodsVO());
    }
  }

  /**
   * 削除確認メッセージ_ボタンクリック時の処理
   *
   * @param {number} closeDetail
   * @memberof KYMW1308Component
   */
  public eventDeleteConfirm_CLICKHandler(closeDetail: number): void {
    if (closeDetail === PlessAlert.Yes) {
      // プロモーション商品登録要求を送信し、プロモーション情報を削除
      this.registPromotionGoodsService.execute(this.KYMW1308Model, this.createRegistPromotionGoodsVO());

      // 要求を行った後、プロモーションNOをクリアする。
      this.inputVO.promotionNo = '';
    }
  }

  /**
   * 排他ロック失敗時の処理を行う
   *
   * @param {*} event
   * @memberof KYMW1308Component
   */
  public lockErr_Handler(event: any, result: any): void {
    this.KYMW1308Model.editLock = false;
    this.setEnabledBtn();
    let LockUserID: string = <string>'';
    let LockUserIDCount: number = <number>0;
    if (result.result.obj.UnlockedInfo.Catalog[0] != null) {
      LockUserID = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.Catalog[0].UserId) + ']';
    } else if (result.result.obj.UnlockedInfo.Page[0] != null) {
      LockUserID = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.Page[0].UserId) + ']';
    } else {
      const LockUserIDTCount: number = result.result.obj.UnlockedInfo.PlanGoods.length;
      for (LockUserIDCount = 0; LockUserIDCount < LockUserIDTCount; LockUserIDCount++) {
        LockUserID = LockUserID +
          '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.PlanGoods[LockUserIDCount].UserId) + ']';
        if (LockUserIDTCount !== (LockUserIDCount + 1)) {
          LockUserID = LockUserID + '\n';
        }
      }
    }
    this.dialogService.openAlertGetMessage('E0235', [LockUserID]);
  }

  /**
   * 排他ロック失敗時の処理を行う
   *
   * @param {*} event
   * @memberof KYMW1308Component
   */
  public lockScc_Handler(event: any): void {
    this.KYMW1308Model.editLock = true;
    this.setEnabledBtn();
  }

  /*--------------------------------------------------------------------------------------------
  /* util area
  /*--------------------------------------------------------------------------------------------*/

  /**
   * 画面項目の初期化
   *
   * @memberof KYMW1308Component
   */
  public initDisplay(): void {

    // ロック情報リリース
    if (this.KYMW1308Model.promotionInfo != null &&
      this.KYMW1308Model.promotionInfo.length > 0) {

      const pCodeList: Array<any> = new Array<any>();

      for (const vo of this.KYMW1308Model.promotionInfo) {
        pCodeList.push(vo.pCode);
      }

      this.LockUtilForPlanGoods('RELEASE',
        this.KYMW1308Model.orderCode,
        this.KYMW1308Model.mediumType,
        pCodeList,
        null,
        null,
        null,
        null,
        false);
    }

    // プロモーション名称
    this.KYMW1308Model.promotionName = '';

    // 区分
    this.KYMW1308Model.promotionDiv = this.DIV_BUNDLE;
    this.setEnabledDiv();

    // 設定単位
    this.KYMW1308Model.setUnit = this.SELECT_ALL;
    this.setEnabledUnit();

    // 設定値一括反映
    this.KYMW1308Model.approvedNum = '';
    this.KYMW1308Model.approvedPrice = '';
    this.KYMW1308Model.wakuwakuPoint = '';
    this.KYMW1308Model.discountPercent = '';
    this.KYMW1308Model.reflectionTarget = this.SELECT_ALL;

    // プロモーション情報
    this.KYMW1308Model.promotionInfo = new Array<any>();

    // フォーカス設定
    this.rbt_Bundle.elementRef.nativeElement.focus();
  }

  /**
   * ボタンの活性制御
   *
   * @memberof KYMW1308Component
   */
  public setEnabledBtn(): void {
    // 一括反映,行削除,全削除
    if (this.KYMW1308Model.editLock === false || this.KYMW1308Model.promotionInfo.length === 0) {
      this.KYMW1308Model.disabledReflection = true;
      this.KYMW1308Model.disabledDelAll = true;
      this.KYMW1308Model.disabledDelRow = true;
    } else {
      this.KYMW1308Model.disabledReflection = false;
      this.KYMW1308Model.disabledDelAll = false;
      this.KYMW1308Model.disabledDelRow = false;
    }

    // 設定
    this.KYMW1308Model.disabledRegist = true;
    this.enabledForViewer(false);

    if (this.KYMW1308Model.editLock === true) {
      this.enabledForViewer(true);

      if (this.KYMW1308Model.promotionDiv === this.DIV_BUNDLE ||
        this.KYMW1308Model.promotionDiv === this.DIV_POINT) {

        switch (this.KYMW1308Model.promotionInfo.length) {
          case 0:
            if (!PlessViewUtilsSub.isEmpty(this.KYMW1308Model.promotionNo)) {
              this.KYMW1308Model.disabledRegist = false;
            }
            break;

          case 1:
            this.KYMW1308Model.disabledRegist = false;
            break;

          default:
            break;

        }
      } else if (this.KYMW1308Model.promotionDiv === this.DIV_MIX) {

        switch (this.KYMW1308Model.promotionInfo.length) {
          case 0:
            if (!PlessViewUtilsSub.isEmpty(this.KYMW1308Model.promotionNo)) {
              this.KYMW1308Model.disabledRegist = false;
            }
            break;

          case 1:
            break;

          default:
            this.KYMW1308Model.disabledRegist = false;
            break;
        }
      }
    }
  }

  /**
   * 区分による画面項目活性制御
   *
   * @returns {void}
   * @memberof KYMW1308Component
   */
  public setEnabledDiv(): void {

    if (!this.KYMW1308Model.editLock) {
      return;
    }

    if (this.KYMW1308Model.promotionDiv === this.DIV_BUNDLE ||
      this.KYMW1308Model.promotionDiv === this.DIV_MIX) {

      this.KYMW1308Model.disabledApprovedNum = false;
      this.KYMW1308Model.disabledApprovedPrice = false;
      this.KYMW1308Model.disabledDiscountPercent = false;

      this.KYMW1308Model.disabledWakuwakuPoint = true;
      this.KYMW1308Model.wakuwakuPoint = '';

      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_NUM_IB].isReadOnly = false;
      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_NUM_TO].isReadOnly = false;
      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_NUM_GU].isReadOnly = false;
      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_NUM_TI].isReadOnly = false;
      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_NUM_SA].isReadOnly = false;
      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_NUM_TK].isReadOnly = false;
      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_NUM_NA].isReadOnly = false;
      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_NUM_NI].isReadOnly = false;
      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_NUM_KU].isReadOnly = false;

      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_PRICE_IB].isReadOnly = false;
      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_PRICE_TO].isReadOnly = false;
      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_PRICE_GU].isReadOnly = false;
      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_PRICE_TI].isReadOnly = false;
      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_PRICE_SA].isReadOnly = false;
      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_PRICE_TK].isReadOnly = false;
      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_PRICE_NA].isReadOnly = false;
      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_PRICE_NI].isReadOnly = false;
      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_PRICE_KU].isReadOnly = false;

      this.dtg_PromotionInfo.columns[COLUMN.WAKUWAKU_POINT_IB].isReadOnly = true;
      this.dtg_PromotionInfo.columns[COLUMN.WAKUWAKU_POINT_TO].isReadOnly = true;
      this.dtg_PromotionInfo.columns[COLUMN.WAKUWAKU_POINT_GU].isReadOnly = true;
      this.dtg_PromotionInfo.columns[COLUMN.WAKUWAKU_POINT_TI].isReadOnly = true;
      this.dtg_PromotionInfo.columns[COLUMN.WAKUWAKU_POINT_SA].isReadOnly = true;
      this.dtg_PromotionInfo.columns[COLUMN.WAKUWAKU_POINT_TK].isReadOnly = true;
      this.dtg_PromotionInfo.columns[COLUMN.WAKUWAKU_POINT_NA].isReadOnly = true;
      this.dtg_PromotionInfo.columns[COLUMN.WAKUWAKU_POINT_NI].isReadOnly = true;
      this.dtg_PromotionInfo.columns[COLUMN.WAKUWAKU_POINT_KU].isReadOnly = true;

    } else if (this.KYMW1308Model.promotionDiv === this.DIV_POINT) {

      this.KYMW1308Model.disabledApprovedNum = true;
      this.KYMW1308Model.disabledApprovedPrice = true;
      this.KYMW1308Model.disabledDiscountPercent = true;
      this.KYMW1308Model.approvedNum = '';
      this.KYMW1308Model.approvedPrice = '';
      this.KYMW1308Model.discountPercent = '';

      this.KYMW1308Model.disabledWakuwakuPoint = false;

      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_NUM_IB].isReadOnly = true;
      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_NUM_TO].isReadOnly = true;
      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_NUM_GU].isReadOnly = true;
      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_NUM_TI].isReadOnly = true;
      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_NUM_SA].isReadOnly = true;
      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_NUM_TK].isReadOnly = true;
      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_NUM_NA].isReadOnly = true;
      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_NUM_NI].isReadOnly = true;
      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_NUM_KU].isReadOnly = true;

      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_PRICE_IB].isReadOnly = true;
      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_PRICE_TO].isReadOnly = true;
      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_PRICE_GU].isReadOnly = true;
      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_PRICE_TI].isReadOnly = true;
      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_PRICE_SA].isReadOnly = true;
      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_PRICE_TK].isReadOnly = true;
      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_PRICE_NA].isReadOnly = true;
      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_PRICE_NI].isReadOnly = true;
      this.dtg_PromotionInfo.columns[COLUMN.APPROVED_PRICE_KU].isReadOnly = true;

      this.dtg_PromotionInfo.columns[COLUMN.WAKUWAKU_POINT_IB].isReadOnly = false;
      this.dtg_PromotionInfo.columns[COLUMN.WAKUWAKU_POINT_TO].isReadOnly = false;
      this.dtg_PromotionInfo.columns[COLUMN.WAKUWAKU_POINT_GU].isReadOnly = false;
      this.dtg_PromotionInfo.columns[COLUMN.WAKUWAKU_POINT_TI].isReadOnly = false;
      this.dtg_PromotionInfo.columns[COLUMN.WAKUWAKU_POINT_SA].isReadOnly = false;
      this.dtg_PromotionInfo.columns[COLUMN.WAKUWAKU_POINT_TK].isReadOnly = false;
      this.dtg_PromotionInfo.columns[COLUMN.WAKUWAKU_POINT_NA].isReadOnly = false;
      this.dtg_PromotionInfo.columns[COLUMN.WAKUWAKU_POINT_NI].isReadOnly = false;
      this.dtg_PromotionInfo.columns[COLUMN.WAKUWAKU_POINT_KU].isReadOnly = false;

    }
  }

  /**
   * 生協単位による画面項目活性制御
   *
   * @returns {void}
   * @memberof KYMW1308Component
   */
  public setEnabledUnit(): void {
    if (!this.KYMW1308Model.editLock) {
      return;
    }

    if (this.KYMW1308Model.setUnit === this.SELECT_ALL) {
      this.KYMW1308Model.disabledCoopIB = true;
      this.KYMW1308Model.disabledCoopTO = true;
      this.KYMW1308Model.disabledCoopGU = true;
      this.KYMW1308Model.disabledCoopTI = true;
      this.KYMW1308Model.disabledCoopSA = true;
      this.KYMW1308Model.disabledCoopTK = true;
      this.KYMW1308Model.disabledCoopNA = true;
      this.KYMW1308Model.disabledCoopNI = true;
      this.KYMW1308Model.disabledCoopKU = true;

      // 生協選択
      this.KYMW1308Model.coopIB = true;
      this.KYMW1308Model.coopTO = true;
      this.KYMW1308Model.coopGU = true;
      this.KYMW1308Model.coopTI = true;
      this.KYMW1308Model.coopSA = true;
      this.KYMW1308Model.coopTK = true;
      this.KYMW1308Model.coopNA = true;
      this.KYMW1308Model.coopNI = true;
      this.KYMW1308Model.coopKU = true;
    } else {
      this.KYMW1308Model.disabledCoopIB = false;
      this.KYMW1308Model.disabledCoopTO = false;
      this.KYMW1308Model.disabledCoopGU = false;
      this.KYMW1308Model.disabledCoopTI = false;
      this.KYMW1308Model.disabledCoopSA = false;
      this.KYMW1308Model.disabledCoopTK = false;
      this.KYMW1308Model.disabledCoopNA = false;
      this.KYMW1308Model.disabledCoopNI = false;
      this.KYMW1308Model.disabledCoopKU = false;

      // 生協選択
      this.KYMW1308Model.coopIB = false;
      this.KYMW1308Model.coopTO = false;
      this.KYMW1308Model.coopGU = false;
      this.KYMW1308Model.coopTI = false;
      this.KYMW1308Model.coopSA = false;
      this.KYMW1308Model.coopTK = false;
      this.KYMW1308Model.coopNA = false;
      this.KYMW1308Model.coopNI = false;
      this.KYMW1308Model.coopKU = false;
    }
  }

  /**
   * バンドル/ミックスマッチの入力チェック
   *
   * @param {string} strPCode
   * @param {string} strGuideGoodsName
   * @param {string} strCoopName
   * @param {string} strSupplyPrice
   * @param {string} strApprovedNum
   * @param {string} strApprovedPrice
   * @param {boolean} blnConfirm
   * @returns {boolean}
   * @memberof KYMW1308Component
   */
  public checkBundleMix(strPCode: string,
    strGuideGoodsName: string,
    strCoopName: string,
    strSupplyPrice: string,
    strApprovedNum: string,
    strApprovedPrice: string,
    blnConfirm: boolean): boolean {

    let strMes: string = <string>'';

    if (strApprovedNum.length < 1) {
      return true;
    }

    if (Number(strApprovedNum) < 2) {
      strMes = '『' + strPCode + ':' + strGuideGoodsName + '』の成立数量（' + strCoopName + '）';
      this.dialogService.openAlertGetMessage('E0142', [strMes, '2'], null);

      return false;
    }

    if (strApprovedPrice.length > 0) {
      if (Number(strApprovedPrice) >= Number(strSupplyPrice)) {
        blnConfirm = true;
      }
    } else {
      strMes = '『' + strPCode + ':' + strGuideGoodsName + '』の成立価格（' + strCoopName + '）';
      this.dialogService.openAlertGetMessage('W0001', [strMes], null);

      return false;
    }

    return true;
  }

  /**
   * 呼出元画面の再表示を行う
   *
   * @memberof KYMW1308Component
   */
  public refleshKYMW1300(): void {
    const outputVO: KYMW1308OutputModel = new KYMW1308OutputModel();
    this.setKYMW1308Parameter(outputVO);
  }

  /**
   * プロモーションＮＯ取得リクエスト用VO設定
   *
   * @returns {KYMW1308GetPromotionNoModel}
   * @memberof KYMW1308Component
   */
  public createGetPromotionNoVO(): KYMW1308GetPromotionNoModel {
    const vo: KYMW1308GetPromotionNoModel = new KYMW1308GetPromotionNoModel();

    // 受注コード
    vo.orderCode = this.KYMW1308Model.orderCode;

    // 媒体区分
    vo.mediumType = this.KYMW1308Model.mediumType;

    return vo;
  }

  /**
   * プロモーション商品情報取得リクエスト用VO設定
   *
   * @private
   * @returns {KYMW1308GetPromotionGoodsInfoModel}
   * @memberof KYMW1308Component
   */
  private createGetPromotionGoodsInfoVO(): KYMW1308GetPromotionGoodsInfoModel {
    const vo: KYMW1308GetPromotionGoodsInfoModel = new KYMW1308GetPromotionGoodsInfoModel();

    // 受注コード
    vo.orderCode = this.KYMW1308Model.orderCode;

    // 媒体区分
    vo.mediumType = this.KYMW1308Model.mediumType;

    // プロモーションＮＯ
    vo.promotionNo = this.KYMW1308Model.promotionNo;

    return vo;
  }

  /**
   * 成立数量算出リクエスト用VO設定
   *
   * @private
   * @returns {KYMW1308CalcApprovedPriceModel}
   * @memberof KYMW1308Component
   */
  private createCalcApprovedPriceVO(): KYMW1308CalcApprovedPriceModel {
    const vo: KYMW1308CalcApprovedPriceModel = new KYMW1308CalcApprovedPriceModel();

    vo.discountPercent = Number(this.KYMW1308Model.discountPercent);

    if (this.KYMW1308Model.reflectionTarget === this.SELECT_ALL) {
      for (let i: number = <number>0; i < this.KYMW1308Model.promotionInfo.length; i++) {
        vo.discountGoodsList.push(this.createDiscountGoodsVO(i));
      }
    } else {
      vo.discountGoodsList.push(this.createDiscountGoodsVO(this.dtg_PromotionInfo.selection.row));
    }

    return vo;
  }

  /**
   * 値引商品VO設定
   *
   * @private
   * @param {number} selectRow
   * @returns {KYMW1308DiscountGoodsModel}
   * @memberof KYMW1308Component
   */
  private createDiscountGoodsVO(selectRow: number): KYMW1308DiscountGoodsModel {
    const vo: KYMW1308DiscountGoodsModel = new KYMW1308DiscountGoodsModel();

    vo.pCode = this.KYMW1308Model.promotionInfo[selectRow].pCode;

    if (this.KYMW1308Model.coopIB) {
      vo.thisTimeSupplyPriceIB = this.KYMW1308Model.promotionInfo[selectRow].thisTimeSupplyPriceIB;
    }

    if (this.KYMW1308Model.coopTO) {
      vo.thisTimeSupplyPriceTO = this.KYMW1308Model.promotionInfo[selectRow].thisTimeSupplyPriceTO;
    }

    if (this.KYMW1308Model.coopGU) {
      vo.thisTimeSupplyPriceGU = this.KYMW1308Model.promotionInfo[selectRow].thisTimeSupplyPriceGU;
    }

    if (this.KYMW1308Model.coopTI) {
      vo.thisTimeSupplyPriceTI = this.KYMW1308Model.promotionInfo[selectRow].thisTimeSupplyPriceTI;
    }

    if (this.KYMW1308Model.coopSA) {
      vo.thisTimeSupplyPriceSA = this.KYMW1308Model.promotionInfo[selectRow].thisTimeSupplyPriceSA;
    }

    if (this.KYMW1308Model.coopTK) {
      vo.thisTimeSupplyPriceTK = this.KYMW1308Model.promotionInfo[selectRow].thisTimeSupplyPriceTK;
    }

    if (this.KYMW1308Model.coopNA) {
      vo.thisTimeSupplyPriceNA = this.KYMW1308Model.promotionInfo[selectRow].thisTimeSupplyPriceNA;
    }

    if (this.KYMW1308Model.coopNI) {
      vo.thisTimeSupplyPriceNI = this.KYMW1308Model.promotionInfo[selectRow].thisTimeSupplyPriceNI;
    }

    if (this.KYMW1308Model.coopKU) {
      vo.thisTimeSupplyPriceKU = this.KYMW1308Model.promotionInfo[selectRow].thisTimeSupplyPriceKU;
    }

    return vo;
  }

  /**
   * プロモーション情報の反映
   *
   * @param {string} approvedNum
   * @param {string} approvedPrice
   * @param {string} wakuwakuPoint
   * @memberof KYMW1308Component
   */
  public reflectPromotion(approvedNum: string,
    approvedPrice: string,
    wakuwakuPoint: string): void {

    if (this.KYMW1308Model.reflectionTarget === this.SELECT_ALL) {
      for (let i: number = <number>0; i < this.KYMW1308Model.promotionInfo.length; i++) {
        this.reflectRow(i, approvedNum, approvedPrice, wakuwakuPoint);
      }
    } else {
      const rowNo: number = this.KYMW1308Model.promotionInfo.findIndex(
        obj => obj.pCode === this.dtg_PromotionInfo.selectedItems[0].pCode);
      this.reflectRow(rowNo, approvedNum, approvedPrice, wakuwakuPoint);
    }
  }

  /**
   * データ行への反映
   *
   * @param {number} rowNo
   * @param {string} approvedNum
   * @param {string} approvedPrice
   * @param {string} wakuwakuPoint
   * @memberof KYMW1308Component
   */
  public reflectRow(rowNo: number, approvedNum: string, approvedPrice: string, wakuwakuPoint: string): void {

    if (this.KYMW1308Model.coopIB === true &&
      this.KYMW1308Model.promotionInfo[rowNo].handlingFlgIB === '1') {

      if (approvedNum.length > 0) {
        this.KYMW1308Model.promotionInfo[rowNo].approvedNumIB = approvedNum;
      }
      if (approvedPrice.length > 0) {
        this.KYMW1308Model.promotionInfo[rowNo].approvedPriceIB = approvedPrice;
      }
      if (wakuwakuPoint.length > 0) {
        this.KYMW1308Model.promotionInfo[rowNo].wakuwakuPointIB = wakuwakuPoint;
      }
    }

    if (this.KYMW1308Model.coopTO === true &&
      this.KYMW1308Model.promotionInfo[rowNo].handlingFlgTO === '1') {

      if (approvedNum.length > 0) {
        this.KYMW1308Model.promotionInfo[rowNo].approvedNumTO = approvedNum;
      }
      if (approvedPrice.length > 0) {
        this.KYMW1308Model.promotionInfo[rowNo].approvedPriceTO = approvedPrice;
      }
      if (wakuwakuPoint.length > 0) {
        this.KYMW1308Model.promotionInfo[rowNo].wakuwakuPointTO = wakuwakuPoint;
      }
    }

    if (this.KYMW1308Model.coopGU === true &&
      this.KYMW1308Model.promotionInfo[rowNo].handlingFlgGU === '1') {

      if (approvedNum.length > 0) {
        this.KYMW1308Model.promotionInfo[rowNo].approvedNumGU = approvedNum;
      }
      if (approvedPrice.length > 0) {
        this.KYMW1308Model.promotionInfo[rowNo].approvedPriceGU = approvedPrice;
      }
      if (wakuwakuPoint.length > 0) {
        this.KYMW1308Model.promotionInfo[rowNo].wakuwakuPointGU = wakuwakuPoint;
      }
    }

    if (this.KYMW1308Model.coopTI === true &&
      this.KYMW1308Model.promotionInfo[rowNo].handlingFlgTI === '1') {

      if (approvedNum.length > 0) {
        this.KYMW1308Model.promotionInfo[rowNo].approvedNumTI = approvedNum;
      }
      if (approvedPrice.length > 0) {
        this.KYMW1308Model.promotionInfo[rowNo].approvedPriceTI = approvedPrice;
      }
      if (wakuwakuPoint.length > 0) {
        this.KYMW1308Model.promotionInfo[rowNo].wakuwakuPointTI = wakuwakuPoint;
      }
    }

    if (this.KYMW1308Model.coopSA === true &&
      this.KYMW1308Model.promotionInfo[rowNo].handlingFlgSA === '1') {

      if (approvedNum.length > 0) {
        this.KYMW1308Model.promotionInfo[rowNo].approvedNumSA = approvedNum;
      }
      if (approvedPrice.length > 0) {
        this.KYMW1308Model.promotionInfo[rowNo].approvedPriceSA = approvedPrice;
      }
      if (wakuwakuPoint.length > 0) {
        this.KYMW1308Model.promotionInfo[rowNo].wakuwakuPointSA = wakuwakuPoint;
      }
    }

    if (this.KYMW1308Model.coopTK === true &&
      this.KYMW1308Model.promotionInfo[rowNo].handlingFlgTK === '1') {

      if (approvedNum.length > 0) {
        this.KYMW1308Model.promotionInfo[rowNo].approvedNumTK = approvedNum;
      }
      if (approvedPrice.length > 0) {
        this.KYMW1308Model.promotionInfo[rowNo].approvedPriceTK = approvedPrice;
      }
      if (wakuwakuPoint.length > 0) {
        this.KYMW1308Model.promotionInfo[rowNo].wakuwakuPointTK = wakuwakuPoint;
      }
    }

    if (this.KYMW1308Model.coopNA === true &&
      this.KYMW1308Model.promotionInfo[rowNo].handlingFlgNA === '1') {

      if (approvedNum.length > 0) {
        this.KYMW1308Model.promotionInfo[rowNo].approvedNumNA = approvedNum;
      }
      if (approvedPrice.length > 0) {
        this.KYMW1308Model.promotionInfo[rowNo].approvedPriceNA = approvedPrice;
      }
      if (wakuwakuPoint.length > 0) {
        this.KYMW1308Model.promotionInfo[rowNo].wakuwakuPointNA = wakuwakuPoint;
      }
    }

    if (this.KYMW1308Model.coopNI === true &&
      this.KYMW1308Model.promotionInfo[rowNo].handlingFlgNI === '1') {

      if (approvedNum.length > 0) {
        this.KYMW1308Model.promotionInfo[rowNo].approvedNumNI = approvedNum;
      }
      if (approvedPrice.length > 0) {
        this.KYMW1308Model.promotionInfo[rowNo].approvedPriceNI = approvedPrice;
      }
      if (wakuwakuPoint.length > 0) {
        this.KYMW1308Model.promotionInfo[rowNo].wakuwakuPointNI = wakuwakuPoint;
      }
    }

    if (this.KYMW1308Model.coopKU === true &&
      this.KYMW1308Model.promotionInfo[rowNo].handlingFlgKU === '1') {

      if (approvedNum.length > 0) {
        this.KYMW1308Model.promotionInfo[rowNo].approvedNumKU = approvedNum;
      }
      if (approvedPrice.length > 0) {
        this.KYMW1308Model.promotionInfo[rowNo].approvedPriceKU = approvedPrice;
      }
      if (wakuwakuPoint.length > 0) {
        this.KYMW1308Model.promotionInfo[rowNo].wakuwakuPointKU = wakuwakuPoint;
      }
    }
  }

  /**
   * プロモーション商品登録リクエスト用VO設定
   *
   * @private
   * @returns {KYMW1308RegistPromotionGoodsModel}
   * @memberof KYMW1308Component
   */
  private createRegistPromotionGoodsVO(): KYMW1308RegistPromotionGoodsModel {

    const registPromotionGoodsVO: KYMW1308RegistPromotionGoodsModel = new KYMW1308RegistPromotionGoodsModel();

    if (this.KYMW1308Model.promotionNo == null) {
      registPromotionGoodsVO.promotionNo = '';
    } else {
      registPromotionGoodsVO.promotionNo = this.KYMW1308Model.promotionNo;
    }
    registPromotionGoodsVO.promotionName = this.KYMW1308Model.promotionName;
    registPromotionGoodsVO.promotionDiv = this.KYMW1308Model.promotionDiv;
    registPromotionGoodsVO.orderCode = this.KYMW1308Model.orderCode;
    registPromotionGoodsVO.mediumType = this.KYMW1308Model.mediumType;

    const registGoodsList: Array<any> = new Array<any>();

    for (const vo of this.KYMW1308Model.promotionInfo) {
      this.createPromotionGoodsRegistVO(
        vo.pCode, this.kymw00Model.COOP_CODE_IB, vo.approvedNumIB, vo.approvedPriceIB, vo.wakuwakuPointIB, registGoodsList);
      this.createPromotionGoodsRegistVO(
        vo.pCode, this.kymw00Model.COOP_CODE_TO, vo.approvedNumTO, vo.approvedPriceTO, vo.wakuwakuPointTO, registGoodsList);
      this.createPromotionGoodsRegistVO(
        vo.pCode, this.kymw00Model.COOP_CODE_GU, vo.approvedNumGU, vo.approvedPriceGU, vo.wakuwakuPointGU, registGoodsList);
      this.createPromotionGoodsRegistVO(
        vo.pCode, this.kymw00Model.COOP_CODE_TI, vo.approvedNumTI, vo.approvedPriceTI, vo.wakuwakuPointTI, registGoodsList);
      this.createPromotionGoodsRegistVO(
        vo.pCode, this.kymw00Model.COOP_CODE_SA, vo.approvedNumSA, vo.approvedPriceSA, vo.wakuwakuPointSA, registGoodsList);
      this.createPromotionGoodsRegistVO(
        vo.pCode, this.kymw00Model.COOP_CODE_TK, vo.approvedNumTK, vo.approvedPriceTK, vo.wakuwakuPointTK, registGoodsList);
      this.createPromotionGoodsRegistVO(
        vo.pCode, this.kymw00Model.COOP_CODE_NA, vo.approvedNumNA, vo.approvedPriceNA, vo.wakuwakuPointNA, registGoodsList);
      this.createPromotionGoodsRegistVO(
        vo.pCode, this.kymw00Model.COOP_CODE_NI, vo.approvedNumNI, vo.approvedPriceNI, vo.wakuwakuPointNI, registGoodsList);
      this.createPromotionGoodsRegistVO(
        vo.pCode, this.kymw00Model.COOP_CODE_KU, vo.approvedNumKU, vo.approvedPriceKU, vo.wakuwakuPointKU, registGoodsList);
    }

    registPromotionGoodsVO.registGoodsList = registGoodsList;

    return registPromotionGoodsVO;
  }

  /**
   * プロモーション商品登録情報VO設定
   *
   * @private
   * @param {string} strPCode
   * @param {string} strCoopCode
   * @param {string} strApprovedNum
   * @param {string} strApprovedPrice
   * @param {string} strWakuwakuPoint
   * @param {Array<any>} registGoodsList
   * @returns {void}
   * @memberof KYMW1308Component
   */
  private createPromotionGoodsRegistVO(strPCode: string,
    strCoopCode: string,
    strApprovedNum: string,
    strApprovedPrice: string,
    strWakuwakuPoint: string,
    registGoodsList: Array<any>): void {

    const vo: KYMW1308PromotionGoodsRegistModel = new KYMW1308PromotionGoodsRegistModel;

    if (strApprovedNum.length > 0 || strWakuwakuPoint.length > 0) {
      vo.pCode = strPCode;
      vo.coopCode = strCoopCode;
      vo.approvedNum = strApprovedNum;
      vo.approvedPrice = strApprovedPrice;
      vo.wakuwakuPoint = strWakuwakuPoint;

      registGoodsList.push(vo);
    }

    return;
  }

  /**
   * 閲覧モード時コンポーネント編集
   *
   * @private
   * @param {boolean} flg
   * @memberof KYMW1308Component
   */
  private enabledForViewer(flg: boolean): void {
    this.KYMW1308Model.disabledPromotionName = !flg;
    if (!PlessViewUtilsSub.isEmpty(this.KYMW1308Model.promotionNo) || this.KYMW1308Model.promotionInfo.length > 0) {
      this.KYMW1308Model.disabledBundle = true;
      this.KYMW1308Model.disabledMix = true;
      this.KYMW1308Model.disabledPoint = true;
    } else {
      this.KYMW1308Model.disabledBundle = !flg;
      this.KYMW1308Model.disabledMix = !flg;
      this.KYMW1308Model.disabledPoint = !flg;
    }
    this.KYMW1308Model.disabledUnitAll = !flg;
    this.KYMW1308Model.disabledUnitCoop = !flg;
    this.KYMW1308Model.disabledCoopIB = !flg;
    this.KYMW1308Model.disabledCoopTO = !flg;
    this.KYMW1308Model.disabledCoopGU = !flg;
    this.KYMW1308Model.disabledCoopTI = !flg;
    this.KYMW1308Model.disabledCoopSA = !flg;
    this.KYMW1308Model.disabledCoopTK = !flg;
    this.KYMW1308Model.disabledCoopNA = !flg;
    this.KYMW1308Model.disabledCoopNI = !flg;
    this.KYMW1308Model.disabledCoopKU = !flg;
    this.KYMW1308Model.disabledApprovedNum = !flg;
    this.KYMW1308Model.disabledApprovedPrice = !flg;
    this.KYMW1308Model.disabledWakuwakuPoint = !flg;
    this.KYMW1308Model.disabledDiscountPercent = !flg;
    this.KYMW1308Model.disabledReflection = !flg;
    this.KYMW1308Model.disabledTargetAll = !flg;
    this.KYMW1308Model.disabledTargetGoods = !flg;
    if (flg) {
      this.dtg_PromotionInfo.selectionMode = SelectionMode.Row;
    } else {
      this.dtg_PromotionInfo.selectionMode = SelectionMode.None;
    }

    this.setEnabledDiv();
    this.setEnabledUnit();
  }

  /**
   * プロモーション商品情報取得更新
   *
   * @memberof KYMW1308Component
   */
  public updatePromotionGoodsInfo(): void {
    //  バンドルミックスマッチ設定画面用インプットVOのチェック
    if (!PlessViewUtilsSub.isEmpty(this.inputVO.promotionNo)) {
      this.KYMW1308Model.promotionNo = this.inputVO.promotionNo;                // プロモーションＮＯ

      // プロモーション商品情報取得要求をサーバに送信
      this.getPromotionGoodsInfoService.execute(this.KYMW1308Model, this.createGetPromotionGoodsInfoVO());
    }
  }

  /**
   * プロモーションNo再取得
   *
   * @memberof KYMW1308Component
   */
  public refleshPromotionNo(): void {
    // プロモーションＮＯ取得要求をサーバに送信
    this.getPromotionNoService.execute(this.KYMW1308Model, this.createGetPromotionNoVO());
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {KYMW1308InputModel} param 受け渡すデータ
   * @memberof KYMW1308Component
   */
  public setInterfaceParam(param: KYMW1308InputModel): void {
    this.inputVO = param;
  }
}
